// OPU draft handoff (step 1 → step 2). The session can't be created until it
// has ≥1 aspiration (contract), so step 1's header (farm/staff/date) is stashed
// in localStorage and handed to the items workspace (opened in a new tab) by key.
// localStorage (not sessionStorage) so it survives the cross-tab jump + refresh.

const PREFIX = 'opu:draft:';

export function saveDraft(header) {
    const key = (globalThis.crypto?.randomUUID?.() || `d${Date.now()}`);
    try { localStorage.setItem(PREFIX + key, JSON.stringify(header)); } catch { /* quota/private mode */ }
    return key;
}

export function readDraft(key) {
    if (!key) return null;
    try {
        const raw = localStorage.getItem(PREFIX + key);
        return raw ? JSON.parse(raw) : null;
    } catch { return null; }
}

export function clearDraft(key) {
    try { localStorage.removeItem(PREFIX + key); } catch { /* ignore */ }
}
